import { ReportModel } from './reports';
export class Client {
  Id: string;
  Name: string;
  DBA: string;
  PrimaryContact: string;
  ContactEmail: string;
  ContactPhone: string;
  AutogenerateEmployeeId: boolean;
  UseNewHireReporting: boolean;
  Status: string;
  StatusEffectiveDate: Date;
  HasWorkersCompensation: boolean;
  UsesWorkersCompRatesAndCodes: boolean;
  OrganizationTypeId: number;
  Allow1099Setup: boolean;
  AllowK1Setup: boolean;
  RequiresWorkersCompCodes: boolean;
  LaborAllocationType: number; // 0: no allocations, 1: by dept, 2: by job code
  IsEmployeeAchAllowed: boolean;
}

export interface ClientAdvisors {
  advisorType: string;
  advisorName: string;
  advisorPhoneNumber: string;
  advisorEmail: string;
}

export class ClientHomePage {
  ClientName: string;
  PayrollTotals: PayrollTotals[] | null;
  QuickReports: HomePageReportModel[] | null;
  NextPayrollProcessDueDate: string;
}

export class ClientFrontPage {
  //The server-side model has a lot more than this.
  //Since this is the only relevant piece, it's the only one
  //I chose to define right now.

  StartDate: Date;
}

export class ClientNote {
  Id: number;
  APSClientCode: string;
  APSClientLocationId: number;
  APSDivisionId: number;
  APSDepartmentId: number;
  Note: string;
  CreatedOn: Date;
  CreatedBy: string;
  LastModifiedOn: Date;
  LastModifiedBy: string;
  Active: boolean;
  ArchivedOn: Date;
  ArchivedBy: string;
  ExpiresOn: Date;
  SourcedFromAgile: boolean;
  IntegrityHash: string;
}

export class ClientSetup {
  HasMultiplePayrollSchedules: boolean;
  HasAutomaticPayrollSchedule: boolean;
  HasMultipleLocations: boolean;
  IsRestaurant: boolean;
  HasWorkersCompCodes: boolean;
  HasLaborAllocation: boolean;

  // Tax-Filing service flags
  TaxFilingServiceEffectiveDate: Date;
  TaxFilingPrefundDays: number;

  //Check Printing flags
  AllowsCheckPrinting: boolean;
  HasCentralChecking: boolean;
  ChecksVoidAfterNDays: number;

  // Timeclock / Swipeclock
  HasTimeclock: boolean;
  AllowTimeclockPunch: boolean;
  AllowTimeclockPTO: boolean;
  AllowTimeclockSchedule: boolean;
  UsesAPIInterface: boolean;
  TimeclockVendorId: string;

  //General Ledger Export Flags
  HasGeneralLedger: boolean;
  HasJobCodes: boolean;
}

export class PayrollTotals {
  PayDate: Date;
  Frequency: string;
  TotalDebitAmount: number;
  TotalCostOfPayroll: number;
  TotalNoEesPaid: number;
}

export class HomePageReportModel {
  PayDate: Date;
  Frequency: string;
  Reports: ReportModel[];
}
